console.log("World Engine Loaded");


class ZaethWorld {

    constructor() {

        this.defaultWorld =
            "essential";

        this.world =
            localStorage.getItem(
                "zaeth-world"
            ) || this.defaultWorld;


        console.log(
            "Constructor World =",
            this.world
        );


        document.body.setAttribute(
            "data-world",
            this.world
        );


        /*
         * ==========================================
         * AUDIO CONTINUATION
         * ==========================================
         */

        this.continueTransitionAudio();

    }


    getWorld() {

        return this.world;

    }


    setWorld(world) {

        if (
            world !== "essential" &&
            world !== "core"
        ) {

            return;

        }


        this.world =
            world;


        localStorage.setItem(
            "zaeth-world",
            world
        );


        document.body.setAttribute(
            "data-world",
            world
        );

    }


    continueTransitionAudio() {

        const audio =
            document.getElementById(
                "zaeth-transition-audio"
            );


        const audioStart =
            sessionStorage.getItem(
                "zaethAudioStart"
            );


        if (
            !audio ||
            !audioStart
        ) {

            return;

        }


        const startTime =
            Number(audioStart);


        const elapsed =
            (
                Date.now() -
                startTime
            ) / 1000;


        const TOTAL_DURATION =
            10;


        /*
         * Audio window already finished.
         */

        if (
            elapsed >=
            TOTAL_DURATION
        ) {

            audio.pause();

            audio.currentTime =
                0;


            sessionStorage.removeItem(
                "zaethAudioStart"
            );


            return;

        }


        /*
         * Start from the correct position.
         */

        const startAudio =
            () => {

                const currentElapsed =
                    (
                        Date.now() -
                        startTime
                    ) / 1000;


                if (
                    currentElapsed >=
                    TOTAL_DURATION
                ) {

                    audio.pause();

                    audio.currentTime =
                        0;


                    sessionStorage.removeItem(
                        "zaethAudioStart"
                    );


                    return;

                }


                audio.currentTime =
                    Math.max(
                        0,
                        currentElapsed
                    );


                audio.volume =
                    0.75;


                audio.play()
                    .catch(() => {

                        /*
                         * If the browser blocks
                         * autoplay after navigation,
                         * try again on the first
                         * user interaction.
                         */

                        const resume =
                            () => {

                                const retryElapsed =
                                    (
                                        Date.now() -
                                        startTime
                                    ) / 1000;


                                if (
                                    retryElapsed >=
                                    TOTAL_DURATION
                                ) {

                                    sessionStorage.removeItem(
                                        "zaethAudioStart"
                                    );

                                    return;

                                }


                                audio.currentTime =
                                    retryElapsed;


                                audio.play()
                                    .catch(() => {});

                            };


                        document.addEventListener(
                            "pointerdown",
                            resume,
                            {
                                once: true
                            }
                        );


                        document.addEventListener(
                            "touchstart",
                            resume,
                            {
                                once: true
                            }
                        );

                    });


                /*
                 * Stop at exactly 10 seconds
                 * from the original world click.
                 */

                const remaining =
                    (
                        TOTAL_DURATION -
                        currentElapsed
                    ) * 1000;


                setTimeout(() => {

                    audio.pause();

                    audio.currentTime =
                        0;


                    sessionStorage.removeItem(
                        "zaethAudioStart"
                    );

                }, remaining);

            };


        if (
            audio.readyState >= 1
        ) {

            startAudio();

        } else {

            audio.addEventListener(
                "loadedmetadata",
                startAudio,
                {
                    once: true
                }
            );

        }

    }

}


window.ZaethWorld =
    new ZaethWorld();